import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EsignatureWebhookEventListStore } from "../../store/EsignatureWebhookEventListStore";

type EsignatureWebhookEventListDialogsProps = {
  store: EsignatureWebhookEventListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EsignatureWebhookEvent.
 * Separado para mantener EsignatureWebhookEventListPage más limpio.
 */
export const EsignatureWebhookEventListDialogs: React.FC<EsignatureWebhookEventListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
